import React from "react";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import { style } from "glamor";
import Typewriter from "typewriter-effect";
import FeelingProud from "./FeelingProud";
import WaveHand from "../../assets/images/waving-hand.png";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";
import "./Greeting.css";

export default function Greeting(props) {
  const theme = props.theme;
  const { lang } = useLanguage();
  const t = translations[lang].greeting;

  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    padding: "15px 30px !important",
    letterSpacing: "0.125rem",
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div className="greeting-text-container">
              <h1 className="greeting-text">
                <span
                  className="greeting-text-highlight"
                  style={{
                    color: theme.accentColor,
                    backgroundImage: `linear-gradient(
                      120deg,
                      transparent 0%,
                      transparent 6%,
                      ${theme.accentBright}33 6%,
                      ${theme.accentBright}33 94%,
                      transparent 94%
                    )`,
                    textShadow: `0 2px 20px ${theme.accentBright}55`,
                  }}
                >
                  {greeting.title2}
                </span>
                <img
                  className="greeting-hand-wave"
                  src={WaveHand}
                  alt="waving-hand"
                />
              </h1>
              <div
                className="greeting-text-div subTitle"
                style={{ color: theme.secondaryText }}
              >
                <span className="greeting-text-static"></span>
                <span style={{ color: theme.accentColor }}>
                  <Typewriter
                    component="span"
                    key={lang}
                    options={{ autoStart: true, loop: true }}
                    onInit={(typewriter) => {
                      typewriter
                        .pauseFor(500)
                        .typeString(t.subTitle1)
                        .pauseFor(1200)
                        .deleteAll()
                        .typeString(t.subTitle2)
                        .pauseFor(1200)
                        .deleteAll()
                        .start();
                    }}
                  />
                </span>
              </div>
              <div
                className="greeting-summary-wrap"
                style={{
                  borderColor: `${theme.accentBright}55`,
                  background: `linear-gradient(
                    135deg,
                    ${theme.accentBright}14 0%,
                    transparent 55%
                  )`,
                  boxShadow: `0 10px 28px ${theme.accentBright}18`,
                }}
              >
                <span
                  className="greeting-summary-bar"
                  style={{
                    background: `linear-gradient(
                      180deg,
                      ${theme.accentBright},
                      ${theme.accentColor}
                    )`,
                  }}
                />
                <p
                  className="greeting-summary"
                  style={{ color: theme.secondaryText }}
                >
                  {(t.summary || greeting.summary)
                    .split(
                      /(8\+ years|8年以上|AI\/ML|Fullstack|フルスタック|measurable ROI|測定可能なROI)/g
                    )
                    .map((part, i) =>
                      /^(8\+ years|8年以上|AI\/ML|Fullstack|フルスタック|measurable ROI|測定可能なROI)$/.test(
                        part
                      ) ? (
                        <strong
                          key={i}
                          className="greeting-summary-em"
                          style={{ color: theme.accentColor }}
                        >
                          {part}
                        </strong>
                      ) : (
                        <React.Fragment key={i}>{part}</React.Fragment>
                      )
                    )}
                </p>
              </div>
              <div className="portfolio-repo-btn-div">
                <a
                  {...styles}
                  className="button"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={greeting.resumeLink}
                >
                  {t.resumeBtn}
                </a>
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
